<article class="responsive-8-4">
	<header class="page-header">
		<div class="breadcrumb-line">
			<stages-breadcrumb [links]="true" [path]="breadcrumb"></stages-breadcrumb>
			@if (self) {
				<stages-process-version
					[type]="$safeNavigationMigration(self.type?.ident)"
					[identity]="self.identity"
				></stages-process-version>
			}
		</div>
		@if (self) {
			<stages-element-name [self]="$any(self)"></stages-element-name>
		}
	</header>

	<ng-container stagesSlot="top"></ng-container>

	<div class="container row">
		<div class="container column col-8">
			<ng-container stagesSlot="left"></ng-container>
		</div>
		<div class="container column col-4">
			<div class="container grouped column">
				<ng-container stagesSlot="rightTop"></ng-container>
			</div>
			<div class="container grouped column">
				<ng-container stagesSlot="rightBottom"></ng-container>
			</div>
		</div>
	</div>
</article>
